export default "__VITE_ASSET__Chl43w$m__"